package store

import it.neckar.open.time.monotonicTimeSource
import kotlin.time.ComparableTimeMark
import kotlin.time.Duration
import kotlin.time.Duration.Companion.minutes
import kotlin.time.TimeSource

/**
 * Idle time after which the loaded data may be outdated.
 */
val StaleDataWarningThreshold: Duration = 15.minutes

/**
 * Tells whether the page has seen no activity for [threshold].
 * Activity is a navigation or a data change; the stale state is kept until the page is reloaded.
 */
class StaleDataTracker(
  /**
   * Idle time after which the data counts as stale
   */
  private val threshold: Duration = StaleDataWarningThreshold,
  private val timeSource: TimeSource.WithComparableMarks = monotonicTimeSource,
) {
  private var lastActivity: ComparableTimeMark = timeSource.markNow()

  private var stale: Boolean = false

  fun markActivity() {
    latchIfExpired()
    lastActivity = timeSource.markNow()
  }

  /**
   * Returns true once [threshold] has passed without activity, and from then on until reload.
   */
  fun isStale(): Boolean {
    latchIfExpired()
    return stale
  }

  /**
   * Keeps an expiry that no poll has seen yet.
   */
  private fun latchIfExpired() {
    if (lastActivity.elapsedNow() >= threshold) {
      stale = true
    }
  }
}
